// Hello button — plays a short audio greeting on click. Toggles
// .is-playing for the visual state. If data-audio is not set, just
// toggles the visual state as a demo.

export default function hello() {
    const btn = document.querySelector("[data-hello]");
    if (!btn) return;

    const src = btn.dataset.audio;
    let audio = null;

    if (src) {
        audio = new Audio(src);
        audio.addEventListener("ended", () => {
            btn.classList.remove("is-playing");
        });
    }

    btn.addEventListener("click", () => {
        const playing = btn.classList.toggle("is-playing");

        if (!audio) {
            // Demo mode: reset visual state after a few seconds
            if (playing) {
                setTimeout(() => btn.classList.remove("is-playing"), 2400);
            }
            return;
        }

        if (playing) {
            audio.currentTime = 0;
            audio.play().catch(() => btn.classList.remove("is-playing"));
        } else {
            audio.pause();
        }
    });
}
